import { useEffect, useState } from 'react';

const BACKEND_URL = window.location.origin;

const TrackingScripts = () => {
  const [trackingCodes, setTrackingCodes] = useState([]);

  useEffect(() => {
    const fetchTrackingCodes = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/admin/tracking/public/active`);
        if (response.ok) {
          const data = await response.json();
          setTrackingCodes(data || []);
        }
      } catch (error) {
        console.error('Error fetching tracking codes:', error);
      }
    };

    fetchTrackingCodes();
  }, []);

  useEffect(() => {
    if (trackingCodes.length === 0) return;

    // Process each tracking code
    trackingCodes.forEach((tracking, index) => {
      const { code, location, name } = tracking;
      
      // Create a unique ID for this script
      const scriptId = `tracking-script-${index}-${name.replace(/\s+/g, '-').toLowerCase()}`;
      
      // Check if already injected
      if (document.getElementById(scriptId)) return;

      // Parse the HTML string and extract scripts
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = code;

      // Find all script tags
      const scripts = tempDiv.querySelectorAll('script');
      
      scripts.forEach((script, scriptIndex) => {
        const newScript = document.createElement('script');
        newScript.id = `${scriptId}-${scriptIndex}`;
        
        // Copy all attributes
        Array.from(script.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });
        
        // Copy inline script content
        if (script.innerHTML) {
          newScript.innerHTML = script.innerHTML;
        }

        // Determine where to inject
        if (location === 'head') {
          document.head.appendChild(newScript);
        } else if (location === 'body_start') {
          document.body.insertBefore(newScript, document.body.firstChild);
        } else {
          document.body.appendChild(newScript);
        }
      });

      // Handle non-script content (like noscript tags)
      const noscripts = tempDiv.querySelectorAll('noscript');
      noscripts.forEach((noscript, noscriptIndex) => {
        const newNoscript = document.createElement('noscript');
        newNoscript.id = `${scriptId}-noscript-${noscriptIndex}`;
        newNoscript.innerHTML = noscript.innerHTML;
        document.body.appendChild(newNoscript);
      });
    });

    // Cleanup function
    return () => {
      trackingCodes.forEach((tracking, index) => {
        const scriptId = `tracking-script-${index}-${tracking.name.replace(/\s+/g, '-').toLowerCase()}`;
        
        // Remove all scripts with this base ID
        document.querySelectorAll(`[id^="${scriptId}"]`).forEach(el => {
          el.remove();
        });
      });
    };
  }, [trackingCodes]);

  // This component doesn't render anything
  return null;
};

export default TrackingScripts;
